{
  "main": {
    "logo": {
      "name": "Быстренко",
      "suffix": ".ру",
      "icon": "ri-flashlight-line",
      "href": "/"
    },
    "links": [
      {
        "label": "Услуги",
        "href": "#services"
      },
      {
        "label": "Решения",
        "href": "#solutions"
      },
      {
        "label": "Интеграции",
        "href": "/integrations"
      },
      {
        "label": "Процесс",
        "href": "#process"
      },
      {
        "label": "Кейсы",
        "href": "#cases"
      },
      {
        "label": "Тарифы",
        "href": "#pricing"
      },
      {
        "label": "FAQ",
        "href": "#faq"
      },
      {
        "label": "Lean",
        "href": "/lean"
      },
      {
        "label": "БроньСРМ",
        "href": "/booker"
      },
      {
        "label": "Аналитика",
        "href": "/analytics"
      }
    ],
    "cta": {
      "label": "Получить консультацию",
      "href": "#contact"
    }
  },
  "analytics": {
    "logo": {
      "name": "Быстренко",
      "suffix": ".ру",
      "icon": "ri-bar-chart-box-line",
      "href": "/"
    },
    "links": [
      {
        "label": "Как это работает",
        "href": "#how-it-works"
      },
      {
        "label": "Демо-отчёты",
        "href": "#demo-reports"
      },
      {
        "label": "Преимущества",
        "href": "#advantages"
      },
      {
        "label": "Калькулятор",
        "href": "#calculator"
      },
      {
        "label": "Интеграции",
        "href": "/integrations"
      }
    ],
    "cta": {
      "label": "Демо-период",
      "href": "#contact-form"
    }
  },
  "lean": {
    "logo": {
      "name": "Lean",
      "suffix": "Ops",
      "icon": "ri-settings-3-line",
      "href": "/lean"
    },
    "links": [
      {
        "label": "Боли",
        "href": "#pains"
      },
      {
        "label": "Потери",
        "href": "#vision"
      },
      {
        "label": "Методология",
        "href": "#methodology"
      },
      {
        "label": "Тарифы",
        "href": "#pricing"
      },
      {
        "label": "Философия",
        "href": "#philosophy"
      }
    ],
    "cta": {
      "label": "Обсудить бардак",
      "href": "#contact"
    }
  },
  "booker": {
    "logo": {
      "name": "Быстренко",
      "suffix": ".ру",
      "icon": "ri-flashlight-line",
      "href": "/"
    },
    "links": [
      {
        "label": "Возможности",
        "href": "#features"
      },
      {
        "label": "Как работает",
        "href": "#how-it-works"
      },
      {
        "label": "Тарифы",
        "href": "#pricing"
      },
      {
        "label": "FAQ",
        "href": "#faq"
      },
      {
        "label": "Контакты",
        "href": "#contact"
      }
    ],
    "cta": {
      "label": "Попробовать бесплатно",
      "href": "#contact"
    },
    "themeLabel": "Светлая / Тёмная"
  },
  "integrations": {
    "links": [
      {
        "label": "Каталог",
        "href": "#categories"
      },
      {
        "label": "Заявка",
        "href": "#lead"
      }
    ],
    "cta": {
      "label": "Обсудить интеграции",
      "href": "#lead"
    }
  }
}
